import React, { useEffect, useState } from "react";
import Pagination from "./Pagination";
import api from "../../utilis/api";
import { toast } from "react-toastify";

const ContentTable = ({ currentPage, totalPages, onPageChange }) => {
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false); // Add Content modal
  const [editModal, setEditModal] = useState(false); // Edit Content modal
  const [form, setForm] = useState({
    section: "",
    page: "",
    title: "",
    subtitle: "",
    shortDetails: "",
    detail: "",
    image: "",
  });

  const [editForm, setEditForm] = useState({
    _id: "",
    section: "",
    page: "",
    title: "",
    subtitle: "",
    shortDetails: "",
    detail: "",
    image: "",
  });

  // Fetch all content
  const getContent = async () => {
    try {
      const response = await api.get("/content/all");
      if (response) {
        setData(response.data.data);
      }
    } catch (error) {
      const message =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Something went wrong";
      toast.error(message, { autoClose: 5000 });
    }
  };

  useEffect(() => {
    getContent();
  }, []);

  // Handle form input change
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleEditChange = (e) => {
    setEditForm({ ...editForm, [e.target.name]: e.target.value });
  };

  // Handle add content form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post("/content/create", form);
      if (response.data.success) {
        toast.success("Content added successfully");
        setShowModal(false);
        setForm({
          section: "",
          page: "",
          title: "",
          subtitle: "",
          shortDetails: "",
          detail: "",
          image: "",
        });
        getContent();
      }
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error.message ||
        "Something went wrong";
      toast.error(message);
    }
  };

  // Open edit modal with selected content
  const handleEditClick = (item) => {
    setEditForm({ ...item });
    setEditModal(true);
  };

  // Handle update content
  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const response = await api.put(
        `/content/update/${editForm._id}`,
        editForm,
      );
      if (response.data.success) {
        toast.success("Content updated successfully");
        setEditModal(false);
        setEditForm({
          _id: "",
          section: "",
          page: "",
          title: "",
          subtitle: "",
          shortDetails: "",
          detail: "",
          image: "",
        });
        getContent();
      }
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error.message ||
        "Something went wrong";
      toast.error(message);
    }
  };

  return (
    <div className="p-4">
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-bold text-white">Manage Pages</h2>
        <button
          className="px-4 py-2 bg-green-500 rounded hover:bg-green-600"
          onClick={() => setShowModal(true)}
        >
          Add Content
        </button>
      </div>

      {/* Content Table */}
      <div className="overflow-x-auto">
        <table className="min-w-full bg-gray-700 text-white rounded-lg">
          <thead>
            <tr className="text-left border-b border-gray-600">
              <th className="px-4 py-3">#</th>
              <th className="px-4 py-3">Page</th>
              <th className="px-4 py-3">Title</th>
              <th className="px-4 py-3">Detail</th>
              <th className="px-4 py-3">Actions</th>
            </tr>
          </thead>
          <tbody>
            {data && data.length > 0 ? (
              data.map((item, index) => (
                <tr
                  key={item._id}
                  className="border-b border-gray-600 hover:bg-gray-600 transition"
                >
                  <td className="px-4 py-3">{index + 1}</td>
                  <td className="px-4 py-3">{item.page}</td>
                  <td className="px-4 py-3">{item.title}</td>
                  <td className="px-4 py-3">{item.detail}</td>
                  <td className="px-4 py-3 flex gap-2">
                    <button
                      className="px-2 py-1 bg-blue-500 rounded hover:bg-blue-600"
                      onClick={() => handleEditClick(item)}
                    >
                      Edit
                    </button>
                    <button className="px-2 py-1 bg-red-500 rounded hover:bg-red-600">
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5} className="text-center py-4">
                  No data found.
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {/* Pagination */}
        {data && data.length > 0 && (
          <div className="mt-4 flex justify-center">
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={onPageChange}
            />
          </div>
        )}
      </div>

      {/* Add Content Modal */}
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-gray-800 text-white p-6 rounded-lg w-full max-w-md">
            <h3 className="text-xl font-bold mb-4">Add Content</h3>
            <form onSubmit={handleSubmit} className="flex flex-col gap-3">
              <input
                type="text"
                name="section"
                placeholder="Section"
                value={form.section}
                onChange={handleChange}
                className="p-2 rounded bg-gray-700"
              />
              <input
                type="text"
                name="page"
                placeholder="Page"
                value={form.page}
                onChange={handleChange}
                className="p-2 rounded bg-gray-700"
              />
              <input
                type="text"
                name="title"
                placeholder="Title"
                value={form.title}
                onChange={handleChange}
                className="p-2 rounded bg-gray-700"
              />
              <textarea
                name="detail"
                placeholder="Detail"
                value={form.detail}
                onChange={handleChange}
                className="p-2 rounded bg-gray-700"
              />
              <div className="flex justify-end gap-2 mt-2">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="px-4 py-2 bg-red-500 rounded hover:bg-red-600"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-green-500 rounded hover:bg-green-600"
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit Content Modal */}
      {editModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-gray-800 text-white p-6 rounded-lg w-full max-w-md">
            <h3 className="text-xl font-bold mb-4">Edit Content</h3>
            <form onSubmit={handleUpdate} className="flex flex-col gap-3">
              <input
                type="text"
                name="section"
                placeholder="Section"
                value={editForm.section}
                onChange={handleEditChange}
                className="p-2 rounded bg-gray-700"
              />
              <input
                type="text"
                name="page"
                placeholder="Page"
                value={editForm.page}
                onChange={handleEditChange}
                className="p-2 rounded bg-gray-700"
              />
              <input
                type="text"
                name="title"
                placeholder="Title"
                value={editForm.title}
                onChange={handleEditChange}
                className="p-2 rounded bg-gray-700"
              />
              <textarea
                name="detail"
                placeholder="Detail"
                value={editForm.detail}
                onChange={handleEditChange}
                className="p-2 rounded bg-gray-700"
              />
              <div className="flex justify-end gap-2 mt-2">
                <button
                  type="button"
                  onClick={() => setEditModal(false)}
                  className="px-4 py-2 bg-red-500 rounded hover:bg-red-600"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-green-500 rounded hover:bg-green-600"
                >
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContentTable;
